import { useEffect, useState } from 'react'

interface IBottomScrollOptions {
  debounce?: number
  offset?: number
}

export default function useBottomScroll(
  callBack: (isBottom: boolean) => void,
  elementId: string,
  options?: IBottomScrollOptions
) {
  let debounceOption = 500
  let offsetOption = 0

  if (options) {
    debounceOption = options.debounce ? options.debounce : 500
    offsetOption = options.offset ? options.offset : 0
  }

  const [debouncedValue, setDebouncedValue] = useState(false)
  const wrapper = document.getElementById('bodyWrapper')
  let element: HTMLElement | null = null
  useEffect(() => {
    element = document.getElementById(elementId)
  }, [])

  function handleScroll(): any {
    if (element) {
      const isBottom = (element.getBoundingClientRect().bottom - offsetOption) >= window.innerHeight

      if (!isBottom) {
        setDebouncedValue(true)
      } else {
        setDebouncedValue(false)
      }
    }
  }

  useEffect(() => {
    wrapper?.addEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const handler = setTimeout(() => {
      callBack(debouncedValue)
    }, debounceOption)

    // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.
    return () => {
      clearTimeout(handler)
    }
  }, [debounceOption, debouncedValue])
}
